import { Link } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Building2, Plus } from 'lucide-react';
import { PageHeader, pageStyles as s } from '../../components/page.tsx';
import { buttonClass, EmptyState, Splash } from '../../components/ui.tsx';
import { useArchivedProperties, useProperties } from '../../lib/properties.ts';
import { PropertyRow } from './PropertyRow.tsx';

export function PropertiesPage() {
  const { t } = useTranslation();
  const { data: properties, isLoading } = useProperties('owner');
  const { data: archived } = useArchivedProperties();

  if (isLoading) return <Splash />;

  const addButton = (
    <Link to="/vuokranantaja/asunnot/uusi" className={buttonClass('primary')}>
      <Plus size={17} aria-hidden="true" />
      {t('properties.add')}
    </Link>
  );

  return (
    <>
      <PageHeader
        title={t('properties.title')}
        subtitle={
          properties?.length ? t('properties.count', { count: properties.length }) : undefined
        }
        actions={addButton}
      />
      {!properties || properties.length === 0 ? (
        <EmptyState
          icon={<Building2 size={22} />}
          title={t('overview.emptyTitle')}
          text={t('overview.emptyText')}
        />
      ) : (
        <ul className={s.propertyList}>
          {properties.map((p) => (
            <li key={p.id}>
              <PropertyRow property={p} to={`/vuokranantaja/asunnot/${p.id}`} />
            </li>
          ))}
        </ul>
      )}
      {archived && archived.length > 0 && (
        <section style={{ marginTop: '2.5rem' }}>
          <h2 className={s.sectionTitle}>{t('archive.listTitle', { count: archived.length })}</h2>
          <ul className={s.propertyList} style={{ opacity: 0.75 }}>
            {archived.map((p) => (
              <li key={p.id}>
                <PropertyRow property={p} to={`/vuokranantaja/asunnot/${p.id}`} />
              </li>
            ))}
          </ul>
        </section>
      )}
    </>
  );
}
